import React from "react";
import Button from "../../../core/Button/Button";
import { SliderPanelItemModel } from "../SliderPanelModel";
import { SolutionsModel } from "../../ListPanel/ListPanelModel";

import "./SolutionsSliderPanelItem.css";
import Utils from "../../../core/Utils/Utils";

const SolutionsSliderPanelItem: React.FC<{
  blok: SliderPanelItemModel;
  selectedItem: string;
  onClick?: () => void;
}> = ({ blok, selectedItem, onClick }) => {
  const solutionsEntity = blok.entity[0]?.content as SolutionsModel;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onClick) {
      onClick();
    }
  };

  if (!blok?.entity || blok.entity.length < 1) {
    return null;
  }

  return (
    <div
      className={`slider-panel-item ${
        selectedItem === solutionsEntity.name ? "selected" : ""
      }`}
      onClick={handleClick}
    >
      {blok.image?.filename && (
        <img
          src={Utils.getCacheUrl(blok.image?.filename)}
          alt=""
          onError={(e) => Utils.handleImageError(e, blok.image?.filename)}
        />
      )}
      <div>
        <div className="item-title">
          <span>{solutionsEntity.name}</span>
          <span className="price">
            <s>${solutionsEntity.priceBeforeDiscount}</s> $
            {solutionsEntity.priceAfterDiscount}
          </span>
        </div>
        <div className="item-summary">{solutionsEntity.summary}</div>
        <div className="feature-text-container">
          {solutionsEntity.listOfBenefits?.thead.map((thead) => {
            const text = thead?.value;
            if (!text) {
              return null;
            }
            return (
              <div
                className="feature-text"
                key={`item-feature-${blok._uid}-${text}`}
              >
                - {text}
              </div>
            );
          })}
          {solutionsEntity.listOfBenefits?.tbody.map((tbody) => {
            if (!tbody?.body[0].value) {
              return null;
            }
            const text = tbody.body[0].value;
            return (
              <div
                className="feature-text"
                key={`item-feature-${blok.tier}-${blok.productName}-${text}`}
              >
                - {text}
              </div>
            );
          })}
        </div>
        <div className="item-disclaimer">{solutionsEntity.disclaimer}</div>
      </div>
      {blok.buttons && blok.buttons.length > 0 && (
        <div className="action-buttons">
          {blok.buttons.map((button) => {
            return <Button blok={button} key={button._uid} />;
          })}
        </div>
      )}
    </div>
  );
};

export default SolutionsSliderPanelItem;
